export default __webpack_public_path__ + "static/media/13.87d2621a.jpg";